import { inject, Injectable } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { combineLatest, from, map, Observable, take } from 'rxjs';

import { UIPermissions } from '../enums/ui-permissions.enum';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  ngxPermissionService = inject(NgxPermissionsService);

  constructor() {}

  canViewPrices = (): Observable<boolean> =>
    from(this.ngxPermissionService.hasPermission(UIPermissions.VIEW_PRICES)).pipe(take(1));

  isPricingEnabled(): Observable<boolean> {
    return combineLatest([this.canViewPrices()]).pipe(map(([canViewPrices]) => canViewPrices));
  }

  hasPermission(permission: UIPermissions): Observable<boolean> {
    return from(this.ngxPermissionService.hasPermission(permission)).pipe(take(1));
  }

  canViewExportOrderHistory = (): Observable<boolean> =>
    from(this.ngxPermissionService.hasPermission(UIPermissions.VIEW_EXPORT_ORDER_HISTORY)).pipe(take(1));

  canViewCustomColorTintBase = (): Observable<boolean> =>
    from(this.ngxPermissionService.hasPermission(UIPermissions.VIEW_CUSTOM_COLOR_TINTBASE)).pipe(take(1));
}
